/* eslint-disable */
import {isCmsPath} from '@shared/_helpers'
import UserApi from '@shared/_api/user';
import {FETCH_CURRENT_USER_SUCCESS} from "./mutation-types";
import VueCookies from "vue-cookies";

const state = {
    user: null,
    showLoginFailAlert: false,
    loadingUser: false,
    apiError: null
};

const getters = {
    hasRole(state) {
        return role => state.user && state.user.roles.some(r => r.name === role);
    },
    canRead(state) {
        return resource => state.user && state.user.authorities.some(a => {
            return a.authority === resource + 'READ' || a.authority === resource + 'WRITE';
        } );
    },
    canWrite(state) {
        return resource => state.user && state.user.authorities.some(a => {
            return a.authority === resource + 'WRITE';
        } );
    },
};

const actions = {
    login({commit, dispatch}, {username, password}) {
        commit('loginRequest', {username});

        return UserApi.authUser(username, password).then(tokenData => {
            let expireDate = new Date(new Date().getTime() + (1000 * tokenData.expires_in)),
                authDetails = {
                    username: username,
                    token: tokenData.access_token,
                    email: username
                };

            $cookies.set('user', authDetails, expireDate);

            commit('loginSuccess', tokenData);

            window.$cookies.remove('hideSamplePopup');

            return dispatch('refreshSessionData');

        }).catch(error => {
            console.log(error);
            commit('loginFailure', error);

            return Promise.reject();
        });
    },
    logout({commit}) {
        return UserApi.logout().finally(() => {
            commit('logout');
            return Promise.resolve();
        });
    },
    refreshSessionData({commit, rootState}) {
        if (!VueCookies.isKey('sessionId')) {
            var expireDate = new Date(new Date().getTime() + (1000 * 7 * 24 * 60 * 60));
            VueCookies.set('sessionId', '_' + Math.random().toString(36).substr(2, 9), expireDate);
        }

        const loggedIn = VueCookies.isKey('user');
        if (loggedIn && !rootState.account.user) {
            return UserApi.fetchCurrentUser().then(user => {
                commit(FETCH_CURRENT_USER_SUCCESS, user);
                return user;
            })
        } else if (loggedIn) {
            return Promise.resolve(rootState.account.user)
        } else {
            return Promise.resolve(null);
        }
    },
    updateUserProfile({commit}, {user}) {
        // TODO
    },
    hideLoginFailAlert({commit}) {
        commit('hideLoginFailAlert');
    }
};

const mutations = {
    [FETCH_CURRENT_USER_SUCCESS](state, user) {
        state.user = user;
    },
    loginRequest(state, user) {
        state.loadingUser = true;
        state.apiError = null;
    },
    loginSuccess(state, tokenData) {
        state.showLoginFailAlert = false;
        state.loadingUser = false;
    },
    loginFailure(state) {
        state.user = null;
        state.showLoginFailAlert = true;
        state.loadingUser = false;
        state.apiError = "Wrong credentials or account not activated.";
    },
    hideLoginFailAlert(state) {
        state.showLoginFailAlert = false;
    },
    logout(state) {
        $cookies.remove('user');
        state.user = null;
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};